import React from 'react'

const SvgMassApp2 = props => (
  <svg id='mass_app2_svg__\u56FE\u5C42_1' x={0} y={0} viewBox='0 0 160 114' xmlSpace='preserve' {...props}>
    <style>
      {
        '.mass_app2_svg__st59{fill:none;stroke:#252a3a;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:2,3}.mass_app2_svg__st60{fill:#fd5c1f}.mass_app2_svg__st61{fill:#fff}'
      }
    </style>
    <linearGradient
      id='mass_app2_svg__SVGID_1_'
      gradientUnits='userSpaceOnUse'
      x1={16.55}
      y1={114.45}
      x2={143.45}
      y2={-12.45}
    >
      <stop offset={0} stopColor='#252a3a' stopOpacity={0.3} />
      <stop offset={0.995} stopColor='#252a3a' />
    </linearGradient>
    <path
      d='M153 101H7c-3.31 0-6-2.69-6-6V7c0-3.31 2.69-6 6-6h146c3.31 0 6 2.69 6 6v88c0 3.31-2.69 6-6 6z'
      fill='none'
      stroke='url(#mass_app2_svg__SVGID_1_)'
      strokeWidth={2}
      strokeMiterlimit={10}
    />
    <linearGradient id='mass_app2_svg__SVGID_2_' gradientUnits='userSpaceOnUse' x1={54} y1={113} x2={104} y2={113}>
      <stop offset={0} stopColor='#252a3a' stopOpacity={0.3} />
      <stop offset={0.995} stopColor='#252a3a' />
    </linearGradient>
    <path fill='none' stroke='url(#mass_app2_svg__SVGID_2_)' strokeWidth={2} strokeMiterlimit={10} d='M54 113h50' />
    <linearGradient
      id='mass_app2_svg__SVGID_3_'
      gradientUnits='userSpaceOnUse'
      x1={72.357}
      y1={115.143}
      x2={85.988}
      y2={101.512}
    >
      <stop offset={0} stopColor='#252a3a' stopOpacity={0.2} />
      <stop offset={0.995} stopColor='#252a3a' stopOpacity={0.8} />
    </linearGradient>
    <path fill='url(#mass_app2_svg__SVGID_3_)' d='M89.13 112H69.21l2.66-10h14.61z' />
    <linearGradient
      id='mass_app2_svg__SVGID_4_'
      gradientUnits='userSpaceOnUse'
      x1={5.104}
      y1={34.254}
      x2={6.18}
      y2={33.178}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M6.03 33.03c-.37-.15-.18.56-.55.65-.37.09-.81.3-.51.39.29.09.96-.04 1.03-.17.06-.13.14-.83.03-.87z'
      fill='url(#mass_app2_svg__SVGID_4_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_5_'
      gradientUnits='userSpaceOnUse'
      x1={2.58}
      y1={34.583}
      x2={3.337}
      y2={33.825}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M3.2 33.98c-.44-.04-.88 0-.96.17-.07.17.4.3.7.3.29 0 .88-.22.77-.26-.11-.03-.51-.21-.51-.21z'
      fill='url(#mass_app2_svg__SVGID_5_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_6_'
      gradientUnits='userSpaceOnUse'
      x1={5.764}
      y1={30.456}
      x2={6.176}
      y2={30.044}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M5.62 30.2c-.15.05.26.35.4.35.15 0 .4-.48.11-.48-.29 0-.14 0-.51.13z'
      fill='url(#mass_app2_svg__SVGID_6_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_7_'
      gradientUnits='userSpaceOnUse'
      x1={21.732}
      y1={63.649}
      x2={55.208}
      y2={30.173}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M6.91 26.64l.22.22c.22.22.59.3.92.35.33.04.33-.22.07-.48s-.33-.22-.55-.26c-.22-.04-.26-.3-.84-.3-.59 0-.52-.35-.59-.52-.07-.17.56-.51.71-.47.15.04.69-.1.69-.1s.96-.43 1.07-.35c.11.09.66-.09.92-.17.26-.09.4-.56.4-.56s.33.13.51.35c.18.22.59 0 .7 0 .11 0 .72.14.72.14s.6-.09.89-.13c.29-.04 1.15.34 1.44.43.29.09 1.84-.29 1.99-.29.15 0 .66.77 1.14.64.48-.13.7.09.81.13.11.04.22.04.4.3.18.26.37.04.63-.13s.22-.35.22-.35l.22-.04c.22-.04.37.09.99.13.63.04.48-.13.92-.3.44-.17.88.22 1.03.17.15-.04.33-.39.44-.22.11.17.29.52.29.52s.48-.43.63-.43c.15 0 .99.08 1.24.04.26-.04.85.05 1.07.27.22.22.77.17 1.07.39.29.22.59-.17.44-.26-.15-.09-.51-.43-.51-.43s-.55-.78-.63-.91c-.07-.13-.18-.13-.33.22-.15.35-.7.35-1.32.39-.62.04-.22-.35-.92-.39-.7-.04-.44-.35-.22-.35s.37-.52.44-.83c.07-.3.33-.26.85-.22.51.04.66-.09 1.18 0 .51.09.48-.26.99-.22.52.04.26.13.55.35.29.22.48.17.88.39s.26.22.44.26c.18.04.81-.09 1.18-.13.37-.04.66-.09.85.17.18.26.15.56.4.78.26.22-.15-.78-.15-1.13 0-.35.51-.04.85-.04.33 0 .7-.13.77.04.07.17-.48.43-.15.83.33.39.55.52.85.52.29 0 .96.09.66.56-.29.48-1.07.43-1.32.43-.26 0-.7.17-.59.43.11.26.7.13 1.1.13.41 0 1.66.13 1.99 0 .33-.13.26-.65-.11-.78s-.07-.39.3-.3c.37.09.73-.13.66 0-.07.13.04.43.04.78 0 .35.11.57.37.48.26-.09.21-.37.47-.42.26-.04.19-.54.04-.93s-.26-.61-.22-.83c.04-.22.44-.26.66-.04.22.22.51.65.51.65s.44.3.59.65c.15.35.18.26.48.04.29-.22.37-.17.63.04.26.22.07.65.07.78s.37 0 .44-.26.37-.26.55-.35c.18-.09.18-.61.18-.61s-.48-.13-.96-.09c-.48.04-.63-.04-.99-.35-.37-.3-.15-.52-.33-.82-.18-.3.59-.48 1.07-.74.48-.26.96-.09.85.56-.11.65-.18.57.37.44.55-.13-.04-.7.22-.74.26-.04.92-.17 1.14-.13.22.04 1.43-.13 1.73-.13.29 0 .77.3 1.1.52.33.22 1.21.52 1.43.65.22.13 1.77.39 1.91.43.15.04.15.56.29 1 .15.43.55.13.7.13.15 0 .66.3.81.52.15.22 1.25.39 1.25.39s-.26.39-.37.52c-.11.13-.37.22-.59.39-.22.17-.48-.04-.77-.26-.29-.22-.81-.35-.92-.26-.11.09-.04.26.04.39.07.13.55.3.85.56.29.26.22.52.26.87.04.35-.29-.13-.66-.22-.37-.09-.4.35-.4.35s-.48-.04-.7-.04c-.22 0 0 0-.4-.35s-.33.22-.55.04c-.22-.17-.44-.43-.55-.35-.11.09-.48-.39-.7-.35-.22.04-1.1-.13-1.32-.04-.22.09-.4.09-.59.17-.18.09-.26-.61-.15-.83.11-.22.37-.26.85-.13s.51 0 .62-.22c.11-.22.22-.43.74-.61.51-.17-.04-.3-.18-.39-.15-.09-.33-.26-.44 0-.11.26-.37.57-.37.57s-.29 0-.7-.04c-.4-.04-.11-.22.07-.3.18-.09.4-.61.22-.74-.18-.13-.26-.22-.59-.13-.33.09-.11-.3-.33-.43-.22-.13-.15.09-.15.26s-.33.13-.33.13-.51-.09-.7 0c-.18.09-.51.26-.4.39.11.13.48.13.59.52.11.39-.48.48-.59.52-.11.04-.55.22-.55.22s-.44-.13-.81-.13c-.37 0-.48.04-.4.22.07.17.26.09.37.09.11 0 .11.22.44.13s.26-.22.55.13c.29.35.59.3 1.07.61.48.3-.07.65-.33.65s-.26-.26-.4-.52c-.15-.26-.74.04-.74.04s-.48.3-.74.3-.44-.04-.11-.35c.33-.3-.4-.35-.4-.78 0-.43-.21.74-.21.96 0 .22-.23-.26-.85-.17s-.51.35-1.32.95c-.81.61-.6.47-.52 1.03.07.56-.14.66.19.75.33.09.22.74.48.69.26-.04.44-.26.96.04.51.3.77.39 1.4.52.63.13.93.06 1.26-.03.33-.09.65.34.65.64s.22.35.18.74c-.04.39.4-.35.4-.35s.18.65.04.74c-.15.09.04.48.22.43.18-.04.44.13.66-.09.22-.22-.11-.87-.11-1.13 0-.26-.22-.39-.33-.65-.11-.26.29-.3.44-.04.15.26.4.04.66-.17.26-.22.26-.61.26-.61s-.44-.69-.77-.87c-.33-.17-.18-.22.15-.3.33-.09 0-.22.07-.7s.07-.78.26-.78c.18 0 .85-.13 1.4-.09.55.04.81.52 1.18.56.37.04.95.13 1.07.35.11.22-.65.35-.39.7s.54.21.8.34c.26.13.55.04.88-.48.33-.52.48-.56.59-.48.11.09.81 1.04.99 1.26.18.22.36.85.4 1.07.04.22.74.06.89.06.15 0 .7.48.77.74.07.26.22.35.7.48s0 .61-.11.87-.18.35-.33.65c-.15.3 0 0 .18.13s.26.3.55.22c.29-.09.44 0 .55.26.11.26.26.48.37.69.11.22 0 .56-.15.35-.15-.22-.62-.09-.62-.09s-.22.26-.29.13c-.07-.13-.22-.3-.48-.22-.26.09-.51 0-.81.04-.29.04-.4-.17-.22-.35.18-.17.22-.82.59-1.09.37-.26.26-.65 0-.65s-.37.39-.51.48c-.15.09-.65-.16-.91.06s-.67.38-.42.47c.26.09-.37.44-.59.44-.22 0-.15-.57-.15-.78 0-.22-.3.13-.3.13s-.59-.39-.81-.13c-.22.26-1.02.15-1.27.41-.26.26-.38.94-.38.94s.22-.13.66-.26c.44-.13.4-.09.77-.3.37-.22.74-.3.99.09.26.39-.11.61-.11.61s.15.3.29.39c.15.09.18-.09.44-.26s.15.35.22.52c.07.17.33.17.48-.04.15-.22.26-.39.37-.26.11.13.22.43.33.74.11.3-.77.39-.92.43-.15.04-.85.22-.96.26-.11.04-.48.43-.77.43-.29 0-.26-.52-.29-.82-.04-.3-.41.04-.44.17-.04.13-.37.09-.62.13-.26.04-.7.35-.7.69 0 .35.52.72.41.89-.11.17-.96.11-1.22.02s-.63.13-.51.3c.11.17.04.43-.22.39-.26-.04-.29.26-.18.48.11.22-.33.65-.44.48-.11-.17-.33-.26-.33 0s.22.62.44.97-.62.42-.88.68c-.26.26-.83 1.15-1.2 1.33-.37.17-.68.71-.49.93.18.22.41 1.13.52 1.43.11.3-.04 1.17-.37 1.13-.33-.04-.15-.56-.48-.69-.33-.13-.51-.91-.59-1.43-.07-.52-.15-.22-.37-.04-.22.17-.44-.35-.55-.48-.11-.13-.66.25-1.1.21-.44-.04-.67.05-.67.18s-.07.52-.48.26c-.4-.26-.48-.26-.88-.26s-.77-.04-.85.13c-.07.17-.48.56-.74.65-.26.09-.74.52-.51.61.22.09.22.7.07 1.04-.15.35-.11.96-.04 1.56.07.61.52 1 .92 1.39.4.39.55.52.96.17.4-.35.55-.13.66-.09.11.04.4-.22.29-.61-.11-.39.15-.74.48-.69.33.04.81-.13 1.07-.09.26.04.4.87 0 1.22s-.18.87-.26 1.26c-.07.39-.4.48 0 .48.41 0 .29.09.55.13.26.04.51-.26.77-.3.26-.04.92.65.81 1-.11.35-.22.95-.18 1.52.04.57.18.61.26.78.07.17.37.57.7.39.33-.17.66-.3.77-.48.11-.17.81.3.74.43-.07.13.26.26.48.13.22-.13.33-.35.55-.69.22-.35.59-.65.77-.7.18-.04.63-.56.92-.48.29.09-.11.52-.15.78-.04.26 0 1 .15 1.04.15.04.07-.52.26-.91.18-.39.55-.61.74-.61.18 0 .33.91.59.65.26-.26.77-.22.88.04.11.26.22.39.22.39s.18-.17.18-.39.59-.44.96-.17c.37.26.22.35.4.39.18.04.37-.56.48-.61.11-.04 0 .7-.26 1.09-.26.39.22.26.22.26l.11.13c.11.13.48-.13.63.13.15.26.41.35.63.83.22.48.47.05.91-.03.44-.09 1.07.55 1.51 1.12.44.57.37 1 .66 1 .29 0 .37.48.37.65 0 .17-.66.57-1.03.65-.37.09-.37.52.22.39s.33-.39.7-.52c.37-.13.74.17.4.69-.33.52-.99.56-.4.65.59.09.26-.09.59-.61.33-.52.29-.35.51-.35.22 0 .7.13.88.3.18.17.66.43.96.65.29.22.66.13.88.04.22-.09.85.26 1.07.61.22.35.77.39 1.03.52s.66.65.7 1.09c.04.43-.4 1.35-.44 1.56-.04.22-.62 1-1.18 1.52-.55.52-.22 1.13-.18 1.39.04.26-.37 1.22-.26 1.43.11.22-.15.7-.37 1-.22.3-.37.87-.51 1.13-.15.26-.63.17-1.07.3-.44.13-.66.26-.66.26s-.77.43-1.21.78c-.44.35.15.95-.07 1.43s-.4.05-.62.61c-.22.56-.37.47-.56.6-.18.13-.29.48-.33.83-.04.35-.4.7-.88 1.22s-.77.43-1.29.26c-.52-.17-.44-1.65-.52-1.43-.07.22-.33.97-.25 1.1.07.13.59.64.77.77.18.13.15.35 0 .57-.15.22-.55 1-.7 1.04-.15.04-1.29.22-1.51.09-.22-.13-.33.3-.29.57.04.26.22.56-.18.48-.41-.09-.96-.39-.96-.17s.11.7.33.7c.22 0 .44-.17.33.13-.11.3-.4.57-.55.7-.15.13-.33.56-.7.87-.37.3-.37.48-.29.61.07.13.62.04.74.13.11.09-.11.7-.26.83-.15.13-.77.74-1.03.91-.26.17-.26.7-.18.96.07.26.66.91.99 1.04.33.13 1.03.09.96.22-.07.13-.88.26-.99.3-.11.04-.7.22-.99.22-.29 0-.85-.35-.96-.35-.11 0 .07-.17.44-.52s-.15-.74-.22-.26-.22.61-.4.61c-.18 0-.4-.3-.52-.43-.11-.13-.59-.26-.51-.78.07-.52-.22-.48-.44-.7-.22-.22.29-.39.22-.61-.07-.22-.4-.09-.44-.39-.04-.3.29-.74.33-.87.04-.13-.22-.39-.26-.61-.04-.22.15-.43.4-.78.26-.35.44-.78.44-.91s-.18-.61-.18-.96.18-.48.26-.96c.07-.48-.26-.3-.26-.7 0-.39.37-.26.29-.65-.07-.39.18-.65.29-.91.11-.26.22-.69.37-1 .15-.3-.15-1-.15-1.13 0-.13.48-.3.26-.56-.22-.26.19-.35.41-.56.22-.22-.16-.96-.05-1.74s.22-2.13.22-2.26c0-.13.04-.65-.15-1-.18-.35-.4-.61-.66-.74s-.59-.52-.77-.56c-.18-.04-1.3-.41-1.3-1.02 0-.61-.39-1.11-.47-1.54-.07-.43-.63-1.39-.66-1.82-.04-.43-.81-.56-.92-1.04-.11-.48.16-.79.24-1.09.07-.3-.05-.99-.09-1.21-.04-.22.33-.93.55-1.07.22-.13.63-.59.77-.59.15 0 .11-.48.26-.96.15-.48-.07-1.13-.18-1.22-.11-.09-.22-.65-.4-.82-.18-.17-.55-.09-.55-.09s.07.39-.26.61c-.33.22-.4-.04-.51-.17-.11-.13-.51-.17-.7-.39-.18-.22-.48-.52-.7-.65-.22-.13-.76-.24-.72-.77.04-.52-.27-.84-.42-.93-.15-.09-.44-.3-.62-.17-.18.13-.51-.26-.77-.22-.26.04-.77-.52-.96-.74-.18-.22-.33-.52-.66-.52s-.37.13-.59.43c-.22.3-.55-.22-.66-.35-.11-.13-.65.09-1.05.09s-.59-.83-.6-1c-.06-.65-1.18-.65-1.43-.83-.26-.17-.52-.83-.4-1 .11-.17-.18-.74-.18-.74s-.52-.7-.7-.7c-.18 0-.77-1.22-1.1-1.56-.33-.35-1.1-1.13-1.25-1.52-.15-.39-.18-1-.55-.69-.37.3-.08.61.29.95.37.35.3.7.81 1.17.52.48.29.96.52 1.17.22.22.99.74.66 1.09-.33.35-.66-.43-.81-.48-.15-.04-.48-.13-.44-.39.04-.26-.29-.48-.55-.87-.26-.39-.37-.17-.7-.17-.33 0-.04-.48.15-.7.18-.22-.18-.52-.4-.61-.22-.09-.52-1.09-.81-1.69-.3-.61-.52-.91-.85-.87-.33.04-.88-.29-1.1-.46-.22-.17-.15-1.15-.52-1.58-.37-.43-.7-1.26-.66-1.74.04-.48.15-1.69.15-2 0-.3-.28-.88-.28-1.01s-.08-.51-.23-.55c-.15-.04-.62-.47-.96-.47-.33 0-.48-.62-.37-.92.11-.3-.29-.82-.48-.82-.18 0-.48-.57-.59-.87-.11-.3-.4-.3-.33-.13.07.17-.04.48.15.57.18.09.33.78.18.87-.15.09-.48-.26-.85-.48-.37-.22-.22-1.09-.22-1.3 0-.22-.51-.43-.74-.43-.22 0-.44.04-.48-.52-.04-.56-.7-.87-.92-.87-.22 0-1.46-.42-1.83-.42-.37 0-.93-.53-1.15-.36-.22.17-.62-.3-.85-.3-.22 0-.1.59-.51.89-.4.3-.67-.29-.89-.07-.22.22-.77.43-.59-.09.18-.52.18-.61-.11-.48s-.37.48-.37.7c0 .22-.51.56-.51.56s.48.04.66 0c.18-.04.04.48-.15.61-.18.13-.44.48-.74.39-.29-.09-.33-.39-.51-.44-.18-.04-.39.56-1.05.95-.66.39-.75-.17-1.01-.04s-1.18.52-1.51.56c-.33.04-.26-.48-.07-.48.18 0 .88-.39 1.07-.52.18-.13.99-.48 1.21-.61.22-.13.59-.35.44-.61-.15-.26-.63.13-.63.13s-.37-.39-.48-.48c-.11-.09-.33.35-.33.35s-.48-.09-.37-.56c.11-.48-.26-.48-.33-.26-.07.22-.7.56-.74.35-.04-.22-.59-.65-.74-1-.15-.35.15-.39.48-.7.33-.3.81-.39 1.21-.35.4.04.66-.52.51-.57-.15-.04-.4-.09-.62.13-.22.22-.77.17-.77.17s-.81 0-1.14-.26c-.33-.26-.51-.65-.51-.65s.66-.3 1.18-.35l.34-.15zm33.68 12.95c.37.05.37-.56.33-.74-.04-.17-.04-.91.11-1.04s.33-.52.74-.56c.4-.04.66.3.62.7-.04.39.07.78.22.78s.59-.3.44-.56c-.15-.26.11-1.13.11-.83 0 .3.3.52.48.48.18-.04-.18-.83-.44-.87-.26-.04-.77-.04-.88 0-.11.04-.74-.22-1.03-.17-.29.04-.73.17-.88.52-.15.35 0 1-.04 1.26-.04.24-.11.98.22 1.03zm2.06 0c.08.2.48.04.7-.22.22-.26.7-.35.85-.56.15-.22.26-.17.62-.35.37-.17.66-.22.52-.43-.15-.22-.92 0-1.03-.09-.11-.09-.88.96-.88.96s-.66.3-.7.43c-.04.13-.19 0-.08.26zm-3.83-3.35c0 .23.37.26.59.13.22-.13.55-.22.7-.26.15-.04.07.22.4.22s.74.13.85.09c.11-.04.44-.56.18-.61-.26-.04-.66-.35-.88-.61-.22-.26-.74.35-1.21.56-.48.22-.63.14-.63.48zm-15.07-1.43c-.3-.12.11.52.29.65s.55.13.59.35c.04.22.15.74.33.7.18-.04.18-.52.04-.7-.15-.17-.7-.69-.81-.69-.11-.01-.33-.27-.44-.31z'
      fill='url(#mass_app2_svg__SVGID_7_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_8_'
      gradientUnits='userSpaceOnUse'
      x1={42.047}
      y1={29.05}
      x2={42.353}
      y2={28.744}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path d='M41.91 28.84c-.1.13.44.32.54.14.1-.17-.29-.46-.54-.14z' fill='url(#mass_app2_svg__SVGID_8_)' />
    <linearGradient
      id='mass_app2_svg__SVGID_9_'
      gradientUnits='userSpaceOnUse'
      x1={43.271}
      y1={29.434}
      x2={43.597}
      y2={29.107}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path d='M43.34 29.1c-.39.13-.02.46.22.35.24-.12.12-.46-.22-.35z' fill='url(#mass_app2_svg__SVGID_9_)' />
    <linearGradient
      id='mass_app2_svg__SVGID_10_'
      gradientUnits='userSpaceOnUse'
      x1={26.986}
      y1={24.057}
      x2={30.83}
      y2={20.212}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M25.05 22.04c-.05.18.22.17.54.17.32 0 .83 0 .98-.09.15-.09.88-.29.86-.03-.03.26.29.67.46.61.17-.06.52-.43.69-.29.17.15.2.49.37.58.17.09.64.09.86 0 .22-.09.83-.09 1.1-.03.27.06 1.05.23 1.13.06.07-.17.29-.2.32-.38.02-.17.15-.72.15-.72s-.15-.32-.39-.17c-.24.14-.32.23-.54.17-.22-.06-.22-.52-.61-.43-.39.09-.47.35-.59.46-.12.12-.39.2-.49.15-.1-.06-.66-.43-.66-.43s-1.18-.06-1.23-.23c-.05-.17-.24-.46-.78-.4s-1.47.43-1.62.43c-.15 0 .17.35-.02.35-.21-.02-.46-.04-.53.22z'
      fill='url(#mass_app2_svg__SVGID_10_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_11_'
      gradientUnits='userSpaceOnUse'
      x1={29.345}
      y1={21.505}
      x2={30.459}
      y2={20.391}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M29.22 20.85c-.28.11-.22.43-.02.43s.69-.2.83-.06c.15.14.52.03.49-.12-.02-.14.15-.73-.15-.75-.3-.02-.71.32-1.15.5z'
      fill='url(#mass_app2_svg__SVGID_11_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_12_'
      gradientUnits='userSpaceOnUse'
      x1={33.244}
      y1={21.343}
      x2={34.49}
      y2={20.097}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M32.52 20.47c-.04.21.2.38.49.38s.93-.17.98-.03c.05.15-.02.26.32.32s.49.12.69.12c.2 0 .12-.38-.05-.64-.17-.26-.12-.23-.56-.38-.44-.14-.88-.14-1.18-.12-.29.03-.61-.05-.69.35z'
      fill='url(#mass_app2_svg__SVGID_12_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_13_'
      gradientUnits='userSpaceOnUse'
      x1={33.252}
      y1={23.128}
      x2={35.093}
      y2={21.288}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M33.01 21.8c-.19.19 0 .78-.07.84-.07.06.02.32.22.26s.29-.61.44-.61.91-.2 1.03.12.12.17.47.2c.34.03.61-.4.64-.55.02-.15-.17-.43-.64-.38-.47.07-1.89-.08-2.09.12z'
      fill='url(#mass_app2_svg__SVGID_13_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_14_'
      gradientUnits='userSpaceOnUse'
      x1={34.427}
      y1={24.311}
      x2={35.686}
      y2={23.051}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M33.92 23.34c-.17.13-.07.55.2.58.27.03.74-.2.78-.03.05.17.22.96.66.7.44-.26.42-.49.54-.52.12-.03-.03-.67-.22-.81-.2-.14-.83-.06-1.01.03-.16.08-.68-.15-.95.05z'
      fill='url(#mass_app2_svg__SVGID_14_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_15_'
      gradientUnits='userSpaceOnUse'
      x1={37.065}
      y1={23.991}
      x2={38.117}
      y2={22.938}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M36.69 23.6c.03.08.22.23.54.17.32-.06.78-.12 1-.14.22-.03.27-.46.02-.49-.25-.03-.44-.29-.66-.2-.21.08-.97.46-.9.66z'
      fill='url(#mass_app2_svg__SVGID_15_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_16_'
      gradientUnits='userSpaceOnUse'
      x1={36.825}
      y1={22.695}
      x2={37.277}
      y2={22.244}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path d='M36.62 22.38c-.11.3.98.46.86.12-.13-.35-.74-.46-.86-.12z' fill='url(#mass_app2_svg__SVGID_16_)' />
    <linearGradient
      id='mass_app2_svg__SVGID_17_'
      gradientUnits='userSpaceOnUse'
      x1={38.111}
      y1={23.19}
      x2={41.143}
      y2={20.158}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M36.81 20.91c-.31-.09-.83-.2-.83-.29 0-.09-.15.41.12.55.27.14.71.4 1.03.55.32.14.93.17 1.13.46.2.29.86.52.86.52l.78.09s.54-.15 1.1-.09c.57.06 1.4.14 1.86.12.47-.03.54-.2.59-.32.05-.12-.86-.35-1.08-.32-.22.03-1.47.03-1.84 0a7.09 7.09 0 00-1.13 0c-.29.03-.51-.23-.74-.38-.22-.14-.71-.61-1-.67-.28-.05-.23-.05-.85-.22z'
      fill='url(#mass_app2_svg__SVGID_17_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_18_'
      gradientUnits='userSpaceOnUse'
      x1={68.27}
      y1={28.543}
      x2={70.487}
      y2={26.326}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M67.57 26.93c-.1.19-.29.2-.1.61.2.4.34.64.52.61.17-.03.76-.06.83.17.07.23.27.44.69.29.42-.14.76-.23.86-.4.1-.17.76-.2.76-.2s.54-.49.34-.7c-.2-.2-.66-.35-.88-.38-.22-.03-.44.2-.93.2-.49 0-.81.23-1 0-.21-.23-1.02-.34-1.09-.2z'
      fill='url(#mass_app2_svg__SVGID_18_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_19_'
      gradientUnits='userSpaceOnUse'
      x1={52.551}
      y1={27.065}
      x2={66.122}
      y2={13.494}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M46.68 21.2c.27.23.43.09.76.17.34.09.6.72.78.81.18.09.43 0 .54-.17.11-.17.27-.78.27-.78s0 .58.27.69c.27.12.94-.09 1.12-.06.18.03 1.23.2 1.52.38.29.17 1.01.29 1.21.67.2.38.22 1.68.34 1.82.11.15.49-.46.58-.61.09-.15.56-.06.72.14.16.2.51.7.49.9-.02.2-.09.52-.22.4s-.36-.09-.27-.32c.09-.23.13-.72-.05-.72h-.34s-.34-.12-.56.32c-.22.43-.05.87.11.87s.52 0 .52.11c0 .12-.38.46-.36.67.02.2.31.9.4 1.04.09.14.56.29.69.32.13.03-.31.06-.2.26.11.2.29.69.54.81.25.12.94.64 1.03.87.09.23.63-.17.74-.2.11-.03.09.61.4.64.31.03.42-.06.69-.32.27-.26.2-.61.22-.87.02-.26 0-.46.29-.38.29.09.45-.06.43-.35-.02-.29-.27-.64.2-.72.47-.09.72-.46 1.01-.46.29 0 1.1.15 1.19 0 .09-.14.47-1.01.72-1.04.25-.03.89.11 1.48 0 .58-.12 1.21-.55 1.41-.52.2.03.69.03.54-.14-.16-.17-.38-.58-.72-.58-.34 0-.39-.89-.3-.89.09 0 .91.34.89.63-.02.29.14.67.58.55.45-.12.38-.55.29-.67-.09-.12-.16-.41-.25-.61s-.3-.84.17-.9c.47-.06 1.36.61 1.33.14-.02-.46 0-.96.13-1.22.14-.26.43-.43.27-.52-.16-.09-.36.12-.52-.32-.16-.43.14-.75.31-.93.18-.17 1.12-1.3 1.64-1.48.51-.17.87-.84.51-.98-.36-.15-1.08-.41-1.55.06-.47.46-.74.9-1.28.75-.54-.14-.62-.91-.93-1.31-.44-.57-.17-1.7-.64-1.62l-.47.09s-.55-.12-.89-.03c-.45.11-.74.43-.99.36-.5-.13-.95.18-1.08.21-1.1.28-1.98-.1-2.14-.13-.13-.02.77.12 1.46 0 .53-.09 1.43-.31 1.87-.4.44-.09.09-.29-.07-.31-.57-.07-1.43-.35-2.11-.39-.53-.03-.88.16-1.41.18-.68.02-1.5-.03-2.03.36-.47.34-1.07.38-1.12.44-.27.35-.51 1.22-.76.99-.25-.23-.29-.81-.6-.58-.31.23-.02.81-.29 1.22-.27.41-1.03.35-1.25.2-.22-.14-.45-.26-1.34-.2-.9.06-1.88.41-1.68.75.2.35-.4.55-.56.38-.16-.17-.87.2-.83.55.04.35-.11.75-.49.67-.38-.09-.65.2-.67.49-.02.29-.87.49-.94.49-.05.01-1.15-.02-.75.33z'
      fill='url(#mass_app2_svg__SVGID_19_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_20_'
      gradientUnits='userSpaceOnUse'
      x1={42.853}
      y1={50.706}
      x2={44.389}
      y2={49.169}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M41.66 49.32c-.04.43.33.3.77.3s1.21-.09 1.36.13c.15.22.81.56.99.74.18.17.77.22.81.04.04-.17-.4-.65-.66-.61-.26.04-.81-.3-1.1-.61-.29-.3-.85-.3-1.07-.3-.22 0-1.1.31-1.1.31z'
      fill='url(#mass_app2_svg__SVGID_20_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_21_'
      gradientUnits='userSpaceOnUse'
      x1={44.229}
      y1={48.507}
      x2={44.589}
      y2={48.147}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path d='M44.34 48.1c-.34.04-.26.52.15.43.4-.08.18-.47-.15-.43z' fill='url(#mass_app2_svg__SVGID_21_)' />
    <linearGradient
      id='mass_app2_svg__SVGID_22_'
      gradientUnits='userSpaceOnUse'
      x1={44.357}
      y1={52.293}
      x2={44.817}
      y2={51.833}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path d='M44.52 51.7c-.34.07-.26.85.15.71.41-.15.18-.78-.15-.71z' fill='url(#mass_app2_svg__SVGID_22_)' />
    <linearGradient
      id='mass_app2_svg__SVGID_23_'
      gradientUnits='userSpaceOnUse'
      x1={49.211}
      y1={51.815}
      x2={49.671}
      y2={51.355}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path d='M49.38 51.22c-.34.07-.26.85.15.71.4-.14.18-.78-.15-.71z' fill='url(#mass_app2_svg__SVGID_23_)' />
    <linearGradient
      id='mass_app2_svg__SVGID_24_'
      gradientUnits='userSpaceOnUse'
      x1={46.73}
      y1={52.102}
      x2={48.052}
      y2={50.779}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M46.03 51.4s.4.09.66.09.4.17.63.3c.22.13.63-.17.77-.17.15 0 .33.52.37-.04.04-.57-.44-.83-.74-.91-.29-.09-.62 0-.84.04-.22.04-.85.69-.85.69z'
      fill='url(#mass_app2_svg__SVGID_24_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_25_'
      gradientUnits='userSpaceOnUse'
      x1={75.502}
      y1={67.659}
      x2={95.117}
      y2={48.045}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M76.84 42.89c.15-.09.74-.3 1.07-.48.33-.17 1.4-.61 1.54-.61.15 0 1.99.04 2.24-.09.26-.13 1.25-.31 1.55.64.29.96-.33.58-.63.75-.29.17.11.57.26.57.15 0 .66.56.92.56s.88.3.88.3.62.56.96.56c.33 0 .89.67 1.26.24.37-.43.54-1.33.91-1.24.37.09.77.43 1.25.43s1.36-.09 1.51.13c.15.22-.99.96-.92 1.13.07.17.22.13.59-.39s.92-.52 1.36-.65c.44-.13.66.69.74.95.07.26.4.74.66 1.3s.51 1.35.81 1.96c.3.61-.03 1.83.26 2.22.29.39 1.06.74 1.25 1.26.18.52.63 1.04.77 1.09.15.04.77 1.04.81 1.3.04.26-.22.83.37.87.59.04 1.1-.3 1.29-.39.18-.09 1.62-.74 1.8-.48.18.26-.26 1.39-.29 1.7-.04.3-1.1 1.78-1.14 2.17-.04.39-.66 1.09-1.07 1.17-.41.09-1.25 1.3-1.54 1.69-.29.39-.77 1.26-.99 1.35-.22.09-.39 1.24-.28 1.42.11.17.13.97.46 1.32.33.35.44.61.29.91-.15.3.07 1 0 1.56s-.7 1.13-.85 1.3c-.15.17-.84.65-1.14 1.09-.3.43-.55.83-.48 1.04.07.22.37 1.3.33 1.56-.03.26-1.01.4-1.31.57-.29.17.13.74.2 1.08.07.35-.51.91-.77 1.22-.26.3-.96 1.35-1.43 1.74-.48.39-1.17.31-1.65.27-.48-.04-1.26.38-1.44.6-.18.22-.44.17-.81-.04-.37-.22-.41-.52-.44-1-.04-.48-.15-.78-.15-.78s-.11-.74-.44-1.09c-.33-.35-.44-.74-.62-1s.34-1 .3-1.48c-.04-.48-.67-1.04-.85-1.34-.18-.3-.55-1.13-.7-1.43-.15-.3-.33-.91-.29-1.78.04-.87.41-1.38.71-1.64s.18-.58-.08-1.1c-.26-.52.04-1.39-.18-1.69-.22-.3-.56-2-.97-2.26-.4-.26-.83-.26-.61-.87.22-.61 0-1.22.37-1.61.37-.39.18-.65-.22-.91s-.26-.39-.59-.09c-.33.3-.77.48-1.03.17-.26-.3-.18-.78-.66-1.13-.48-.35-1.24-.23-1.43-.14-.18.09-.56.84-1.07.92-.51.09-.88-.04-1.4-.04-.51 0-.96.04-1.03.35-.07.3-.18.48-.51.17-.33-.3-.99-1-.99-1s-.61-1.2-.8-1.72c-.18-.52-.82-.54-1.52-.93-.7-.39-.29-.83-.37-1.26-.07-.43-.44-.61-.26-.65.18-.04.15-.35.55-.96.41-.61.15-1.26.07-1.61-.07-.35-.44-.87-.07-1.43.37-.56.6-1.91.89-2.26.3-.35 1.17-.69 1.57-.91.4-.22.15-.78.37-1.43.22-.65.55-.96.66-.96.11 0 .52-.45.95-.74.32-.2 1.1.07 1.24-.02zm16.07 17.85c-.1-.19-.74-.13-.85.09-.11.22-.22 1.22.11 1.3.34.09.93-1.04.74-1.39z'
      fill='url(#mass_app2_svg__SVGID_25_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_26_'
      gradientUnits='userSpaceOnUse'
      x1={96.434}
      y1={72.961}
      x2={100.931}
      y2={68.464}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M99.6 67.17c-.46-.16-.51.57-.88 1.04-.37.48-.77.87-.92.83-.15-.04-.96.3-.7.95.26.65.22 1.3-.04 1.61-.26.3.22 1.17.15 1.65-.08.48.11.78.63.78.51 0 .7-.22.92-.78.22-.57.26-1.13.48-1.61.22-.48.41-1.48.52-1.74.11-.26.33-1.09.29-1.56-.04-.47-.19-1.08-.45-1.17z'
      fill='url(#mass_app2_svg__SVGID_26_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_27_'
      gradientUnits='userSpaceOnUse'
      x1={112.356}
      y1={57.865}
      x2={113.668}
      y2={56.552}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M112.95 56.01c-.24.12-.48 2.22-.04 2.39.44.17.74-1.3.59-1.52-.14-.22-.22-1.04-.55-.87z'
      fill='url(#mass_app2_svg__SVGID_27_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_28_'
      gradientUnits='userSpaceOnUse'
      x1={81.657}
      y1={40.633}
      x2={82.282}
      y2={40.009}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M81.99 39.8c-.35 0-.52.65-.29.87.22.22.44.17.63-.13.18-.3-.15-.74-.34-.74z'
      fill='url(#mass_app2_svg__SVGID_28_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_29_'
      gradientUnits='userSpaceOnUse'
      x1={79.245}
      y1={40.638}
      x2={79.557}
      y2={40.326}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path d='M79.2 40.5c-.09.16.29.22.37.04.07-.17-.12-.52-.37-.04z' fill='url(#mass_app2_svg__SVGID_29_)' />
    <linearGradient
      id='mass_app2_svg__SVGID_30_'
      gradientUnits='userSpaceOnUse'
      x1={84.015}
      y1={41.839}
      x2={84.615}
      y2={41.239}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M83.57 41.24c-.13.09.22.39.41.48.18.09.33.35.48.39.15.04.62 0 .48-.43-.15-.43-.48-.43-.59-.43-.11-.01-.59-.14-.78-.01z'
      fill='url(#mass_app2_svg__SVGID_30_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_31_'
      gradientUnits='userSpaceOnUse'
      x1={73.762}
      y1={34.415}
      x2={75.477}
      y2={32.7}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M74.78 32.46c-.33.07-.37.48-.59.48-.22 0-.48.09-.4.39.07.3.22.52 0 .65s.04.65.33.7c.29.04.63-.22.88-.35.26-.13.63-.39.63-.78s-.07-.74-.22-.91c-.15-.18-.4-.22-.63-.18z'
      fill='url(#mass_app2_svg__SVGID_31_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_32_'
      gradientUnits='userSpaceOnUse'
      x1={75.395}
      y1={34.525}
      x2={78.327}
      y2={31.593}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M75.19 31.16c-.3.12-.18.56-.04.78.15.22.4.69.77.87.37.17 1.14.35.85.52-.3.17-1.15 1.03-1.22 1.29-.07.26.96.14.96.14s-.22.3-.04.39c.18.09.3-.3.59-.3s.88.22 1.18.22c.29 0 .77-.48.74-.78-.04-.3-.4-.78-.74-.96-.33-.17-.7-.96-.92-1.13-.22-.17.82-.75.56-1.05-.26-.3-1.04-.12-1.33-.34-.29-.22-.55.04-.74.3-.18.27-.4-.04-.62.05z'
      fill='url(#mass_app2_svg__SVGID_32_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_33_'
      gradientUnits='userSpaceOnUse'
      x1={89.842}
      y1={57.353}
      x2={138.831}
      y2={8.364}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M77.62 37.2c-.04-.39-.77-.74-1.25-.83-.48-.09-.41-.35.11-.39.52-.04.48-.26.92-.35.44-.09.88-.22 1.21-.26.33-.04.33-.39.33-.65s.92-.35.92-.35.52-.56.81-.82c.29-.26.81-.22 1.21-.09.4.13-.04-.3-.18-.52-.15-.22-.04-.7.07-.96.11-.26.77-.39.96-.3.18.09 0 .48.04.83s.33.56.33.56l.3-.04h.48c.48 0 .5.01.87-.12s.64.03.78-.05c.15-.09.55-.09 1.1.13s.26-.39.37-.74c.11-.35.33-.96.7-.91.37.04.66.3.96.09.29-.22-.55-.52-.55-.65s.7-.13 1.32-.17c.63-.04.99 0 1.29-.09.29-.09-.22-.7-.33-.7-.11 0-.85.09-1.21.04-.37-.04-.77.26-1.1.35-.33.09-.41-.52-.59-.78s-.26-.74.22-1 1.32-.83 1.47-1.09c.15-.26-.59-.22-1.29-.17-.7.04.11.26-.55 1.04s-.99.26-1.51.78c-.51.52-.15.56.33.74.48.17.07.7-.04.83-.11.13-.66.61-.59.96.07.35-.37.56-.37.56s-1.36.35-1.62.39c-.26.04-.33-.22-.26-.48s-.3-.87-.33-1.26c-.04-.39-.59.17-.63.43-.04.26-.74.3-1.14.13-.41-.17-.63-.83-.55-.96.07-.13-.22-.78-.22-.96 0-.17.86-1.44 1.56-1.61.7-.17 1.53-.6 2.01-1.04.48-.43.7-.96.85-1.09.15-.13 2.69-1.57 3.61-1.74.92-.17 2.94.88 3.27.96.33.09.52.22 1.32.57.81.35 1.57-.03 2.09.05.52.09.78.64 1.11.81.33.17 0 .3-.81.61-.81.3-1.36.22-1.8.04-.44-.17-.7-.17-.37.09.33.26.22.39.26.78.04.39.55.04.66-.04.11-.09.11-.26.52.04.4.3.55.13.73.09.18-.04.04-.52.15-.7.11-.17.55-.17.66-.26.11-.09.37-.22.59-.26.22-.04.18.39.41.52.22.13.11-.57.04-.74-.07-.17-.15-.65-.04-.78.11-.13.88-.22 1.07-.04.18.17-.29.7-.18 1 .11.3.37-.17.55-.43.18-.26.59 0 1.25-.13s.52-.56 1.21-.3c.7.26.52.26.74 0 .22-.26.62.04 1.03-.13.41-.17.41 0 .7.17s.66-.35.81-.52c.15-.17.74-.17 1.03-.13.29.04.66.26.96.26.29 0 .77.26.77.26s.63.26.77.09c.15-.17-.04-.39-.59-.7-.55-.3-.33-.82 0-.87.33-.04.3-.26.55-.43.26-.17.59-.83.88-.69.29.13.55.39.92.61.37.22.04.52-.04.74-.07.22.07 1.04.18 1.17.11.13-.11.61-.4.83-.29.22-.7.69-.59.78.11.09.99-.39.99-.39s.55-.78.81-1c.26-.22.51-.22.59.04.07.26.48.35.85.17.37-.17 0-.3-.04-.7-.04-.39-.63-.17-.96-.09-.33.09-.59.48-.7.48-.11 0-.11-.26-.04-.65s-.15-.61-.15-.82c0-.22.11-.22.37-.65.26-.44.26.3.29.69.04.39.29.22.52.17.22-.04.11-.56.3-.83.18-.26.59-.3.95.09.37.39.33.26.77.43.44.17.48.22.52.61.04.39.33.43.51.3s.04-.65-.07-.82c-.11-.17-.99-.48-1.29-.78-.29-.3.15-.3.48-.3.33 0 .96.04.96.04s.7-.17 1.07-.48c.37-.3.63-.3.99-.48.37-.17.96-.17 1.32-.09.37.09.62-.17.99-.35.37-.17.85-1.31.88-.22 0 .14 1.03.35 1.18.3.15-.04.52-.1 1.07-.44 1.07-.65.14-.96.55-.35.14.21.59-.17 1.36.22.77.39 0 0 .22.26s.33-.04.85-.13.85 0 1.18.04c.33.04 1.07.04 1.4.3.33.26-.22.83-.4 1-.18.17.29.3.44.26.15-.04 1.36 0 1.91.09.55.09.77.39 1.03.39s.66-.13.81-.3c.15-.17 1.07-.26 1.36-.3.29-.04 1.1 0 1.21.09.11.09.22.52.22.87s.33.65.59.7c.26.04.74-.52.92-.61.18-.09.4.39.51.26.11-.13 1.03.04 1.4-.17.37-.22.59 0 .77-.09.18-.09.48-.56.48-.74 0-.17.15-.3 0-.56-.15-.26-.66-.09-1.21-.26-.55-.17.02-1.08.18-.61.09.27.59 0 .95.09.37.09.22-.13.41-.13.18 0 .85.22 1.21.22.37 0 .66.48.66.48s-1.03.35-1.25.35c-.22 0-.07.35.11.35s.44.13.7.35c.26.22 1.4 0 1.54 0 .15 0 .59.22 1.03.52.44.3.73.43.73.43s.63 0 1.25-.09 1.43-.09 1.58.04c.15.13.55.26.85.56.29.3.51.17.92.13.4-.04.81-.13 1.18-.13.37 0 1.58-.04 1.8.35.22.39.48.3.48.3s.33-.7.48-.83c.15-.13.63.09.92.26.29.17 1.73 0 2.1.09.37.09.88.52.59.87-.29.35.22.96.11 1.3-.11.35-.41.39-.7.48-.29.09.29.52.55.83.26.3-.15.39-.4.26-.26-.13-.92.04-1.76.3-.85.26-1.18.78-2.06.82-.88.04-.52-.04-1.62-.04s-1.07.35-1.29.78c-.22.43.11.35 0 .69-.11.35-.29.74-.29 1.04 0 .3-.66.35-.88.61-.22.26-.59.91-1.21 1.39-.62.48-1.06 1.22-1.06 1.22s.11-.74.4-1.26c.29-.52-.33-1.26-.37-1.83-.04-.56.18-.74.55-1.26.37-.52 1.25-.7 1.62-.96.37-.26 1.88-1.48 1.88-1.48s-.29.22-.66.39c-.37.17-.81.52-1.1.52-.29 0-.18-.35-.22-.69-.04-.35-.74-.09-.99.26-.26.35-.74.56-1.25 1-.52.43-.37.39-.7.43-.33.04-.88-.22-1.14-.43-.26-.22-.52.17-1.32.22-.81.04-1.73-.09-2.1-.04-.37.04-1.29 1.3-1.84 1.52-.55.22-1.25.61-1.07.91.18.3.51-.26.66-.26.15 0-.11.61.22.61s.51-.22.85-.26c.33-.04.59.3.66.78.07.48-.15.87-.29 1.48-.15.61-.37 1.22-.96 1.74s-1.54 1.48-1.73 1.74c-.18.26-.84.04-.96-.13-.11-.17-.44.39-.7.52-.26.13-.52.39-.52.74s-.73.35-.73.56c0 .22.44.83.62 1.13.18.3-.04 1.26-.37 1.48-.33.22-.48.48-.92.17-.44-.3-.07-.48.11-.96s-.18-.74-.26-.87c-.07-.13-.37.26-.51.3-.15.04-.15-.39-.04-.65.11-.26-.07-.82-.18-.87-.11-.04-.81.65-1.1.61-.29-.04-.04-.82.07-1.04.11-.22-.22-.04-.44.17-.22.22-.7.7-.88.65-.18-.04-.55.35-.26.61.29.26.41.48.59.52.18.04.66-.09.85-.13.18-.04.55.3.18.7-.37.39-1.14.44-.99.7.15.26.51.65.81 1.26.29.61.18 1.26.26 1.74.07.48-1.07 1.48-1.4 1.78-.33.3-.66 1.04-1.21 1.39-.55.35-1.73.65-1.91.52-.18-.13-.7.22-.66.7.04.48.29.43.29.56 0 .13-.37.65-.51.87-.15.22-.66 0-.59-.65.07-.65.44-.91.4-1.22-.04-.3-.37-.48-.59-.22-.22.26-.92 1-.92 1s.26.78.59 1.09c.33.3.55.74.99 1.39.44.65.11 1.22 0 1.7s-.48.48-.77.56c-.3.09-.37.22-.48.48-.11.26-.64 1.51-.72 1.29l-.53-1.68s-.33-.78-.81-1.17c-.48-.39-.66-.56-.66-.17s-.29 1.13-.29 1.39-.66-.78-.66-1.22c0-.43-.11-1.17-.07-1.87.04-.7-.77-.04-.77-.04s-.63 1.56-.81 1.56c-.18 0 0-1.43.04-1.95s-.18-1-.29-1.17c-.11-.17-.74-.87-.85-1.35-.11-.48-.33-.3-.55-.04-.22.26-.15.26-1.03.26s-.85.65-1.29 1.04c-.44.39-.81 1.13-1.32 1.39s-.74.52-.74.83c0 .3.21 1.31.1 1.74-.11.44-.39.82-.65 1.26-.26.43-.48 1.13-.7 1.13-.22 0-.3-.61-.3-1s-.62-1.3-.77-1.61c-.15-.3-.7-1.65-.7-1.65s-.44-1.43-.4-1.83c.04-.39.04-1.48.04-1.48s-.59.7-.85.65c-.26-.04-.51-.52-.48-1.09.04-.56-.44-.52-.7-.61-.26-.09-.59-.87-.77-.87-.18 0-.3 0-.44.26-.15.26-.92.22-1.1.22-.18 0-1.29-.04-1.62-.17-.33-.13-.7-.91-.88-1-.18-.09-.74.48-.96.39-.22-.09-.66-.52-1.14-.78-.48-.26-.62-.87-.81-1.26-.18-.39-.81.22-.74.65.07.43.88 1 .88 1.3 0 .3.15.39.55.78.41.39.07.61.33.69.26.09.63-.35.99-.56.37-.22.33-.52.52-.52.18 0 .15.56.44.61.29.04 1.07.56 1.25.91.19.35-.18.56-.33.87-.15.3-.59 1.17-.96 1.52-.37.35-.77.82-1.32.95s-.62.48-1.07.52c-.44.04-1.65.74-1.84.87-.18.13-1.18.48-1.47.35-.3-.13-.41-1-.52-1.65-.11-.65-.26-1-.37-1.26-.11-.26-.77-.96-.92-1.09-.15-.13-.51-1.17-.55-1.61-.04-.43-.44-.26-.51-.74-.08-.48-.48-1.13-.55-1.43-.07-.3-.81.04-1.1.09-.29.04-.85-.26-.77-.96.07-.69.37-.69.74-.69s.22-.22.59-.65c.37-.43.48-1.3.51-1.87.04-.57-.26-.3-.55-.22-.29.09-.74.22-.88.17-.15-.04-.74-.26-.85-.13-.11.13-.74.04-.88-.17-.15-.22-.88-.48-.96-.65-.07-.17 0-1.22-.15-1.48s-.48.04-.66.22c-.18.17-.7.3-.55.43.15.13.63.39.59.74-.04.35-.37.44-.55.61-.18.17-.85.86-.96.64-.11-.22-.18-1.6-.29-1.77-.11-.17-.44-.61-.55-1-.11-.39-.51-.52-.77-.83-.26-.3-.99-.78-1.29-1.13-.29-.35-.81-.61-.85-.17-.04.43.52.52.74.96.22.43.7.7.96.83s.96.7.96.7-.29.13-.55.09c-.26-.04.15.94.11 1.24-.04.3-.48-.11-.55-.46-.07-.35-.29-.74-.44-.87-.15-.13-1.1-.48-1.25-.57-.15-.09-.77-.56-.84-.96-.07-.39-.63-.43-.77-.35-.15.09-.7.56-.96.56s-.66-.22-.96-.26c-.29-.04-.33.56-.44.91-.11.35-.59.09-.84.39-.26.3-.7.61-.59.87.11.26.29.26-.04.48-.33.22-.52.65-.85.69-.33.04-.77.22-.96.09-.18-.13-.33.43-.44.56-.11.13-.3-.39-.48-.61-.18-.22-.66-.04-.81-.09-.15-.04-.3-.43-.48-.61-.18-.17-.15-.56 0-.7.15-.13.29-.35.18-.74-.11-.39-.18-1.26.18-1.43.37-.17 1.25 0 1.69 0 .44 0 1.2.18 1.32-.09.16-.33.23-.76.2-1.15zm13.86-7.65c-.13.41.85.74 1.03.43.18-.3-.85-1.04-1.03-.43zm-1.25 10.52c.07.17.44-.26.73-.26s.96.13 1.14-.17c.18-.3.77-.35 1.25-.26.48.09.88.48 1.21.52.33.04 1.21-.04 1.51-.13.29-.09.22-.7-.26-1-.48-.3-.88-.78-1.32-.96-.44-.17-.59-.35-.33-.43.26-.09.59-.43.22-.43s-.7.13-.74.35c-.03.22-.26.48-.4.56-.15.09-.52.43-.63.17-.11-.26-.51-1.04-.7-1.09-.18-.04-.48 0-.7.43-.22.43-.48.87-.7 1.04-.22.17-.51.7-.29.78.23.09.01.88.01.88zm8.42-3.05c-.45.35-.59.83-.41 1.13.18.3.7 1.26.96 1.35.26.09 1.18.26.81.65-.37.39-.44.52-.77.48-.33-.04-.18 1.04.07 1.13.26.09 1.03.39 1.29.43.26.04 1.1-.09 1.07-.35-.04-.26-.18-1.3-.48-1.56-.29-.26.41-.52.22-.74-.18-.22-.44-.13-.59-.39-.15-.26-.22-.52-.44-.7-.22-.17-.4.17-.37-.3.04-.48.55-.78.77-.52.22.26.88.13 1.03 0 .15-.13-.29-.52-.4-.78-.11-.26-.85-.48-.96-.39-.11.09-.4.35-.7.56-.29.22-.88-.17-1.1 0z'
      fill='url(#mass_app2_svg__SVGID_33_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_34_'
      gradientUnits='userSpaceOnUse'
      x1={101.619}
      y1={25.404}
      x2={106.777}
      y2={20.246}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M102.88 24.73c-.27.32-.84.22-1.25-.04-.4-.26-.88-.3-1.1-.39-.22-.09.04-.61.29-.74.26-.13.96-.52 1.47-.78s.66-.78 1.03-.78 2.13-.43 2.35-.35c.22.09 1.29.17 1.51-.17.22-.35.99-.13.81.17-.18.3-.85 1-1.29.87-.44-.13-1.69-.09-2.24 0-.55.09-1.07.48-1.54.78-.48.3-.37.65-.18.7.17.03.36.47.14.73z'
      fill='url(#mass_app2_svg__SVGID_34_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_35_'
      gradientUnits='userSpaceOnUse'
      x1={139.019}
      y1={36.317}
      x2={141.097}
      y2={34.239}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M140.09 33.38c-.21.07-.85-.09-.63.52.22.61.26 1.04.22 1.52-.04.48 0 1.48.07 1.61.07.13.37.43.55.35.18-.09-.07-.95-.07-1.13 0-.17.26-.43.41-.48.15-.04 0-.78-.18-1.09-.18-.3-.44-.48-.29-.52.15-.04.33-.39.22-.48-.12-.09-.05-.39-.3-.3z'
      fill='url(#mass_app2_svg__SVGID_35_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_36_'
      gradientUnits='userSpaceOnUse'
      x1={139.172}
      y1={39.714}
      x2={140.91}
      y2={37.977}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M139.72 37.81c-.27.08-.37.52-.37.65s-1.03.39-.7.74c.33.35.66.09 1.18.04.51-.04.99-.22.99-.22s.77.04.66-.39c-.11-.43-.92-.48-1.07-.43-.14.04-.4-.48-.69-.39z'
      fill='url(#mass_app2_svg__SVGID_36_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_37_'
      gradientUnits='userSpaceOnUse'
      x1={134.786}
      y1={44.88}
      x2={139.663}
      y2={40.004}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M138.87 39.5c-.27.19-.11.96-.33 1.48-.22.52-.4 1-.55 1-.15 0-.92.35-1.14.61-.22.26-1.29-.22-1.43 0-.15.22-.44.48-.63.65-.18.17-.7.04-.59.56.11.52.37 1 .59 1s.52-.17.52-.65.51 0 .77-.04.4-.35.51-.69c.11-.35-.15.17.29.3.44.13.59-.22.59-.35 0-.13.81-.35.96-.48.15-.13.74-.35.77-.52.04-.17 0-1.17.18-1.26.18-.09.44-.09.15-.7-.29-.61-.29-1.17-.66-.91z'
      fill='url(#mass_app2_svg__SVGID_37_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_38_'
      gradientUnits='userSpaceOnUse'
      x1={130.049}
      y1={49.283}
      x2={131.08}
      y2={48.252}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path d='M130.78 48.06c-.54.1-.88 1.48-.44 1.44.44-.05.92-1.53.44-1.44z' fill='url(#mass_app2_svg__SVGID_38_)' />
    <linearGradient
      id='mass_app2_svg__SVGID_39_'
      gradientUnits='userSpaceOnUse'
      x1={153.209}
      y1={81.167}
      x2={154.698}
      y2={79.677}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M153.47 78.82c-.15.09 0 .57.15.74.15.17.22.78.18.96-.04.17-.66.39-.37.61.29.22.85 0 .77.26-.07.26-.37.61-.04.7.33.09.44-.3.59-.61.15-.3.26-.57.51-.74.26-.17 0-.56-.15-.56s-.22.22-.55 0c-.33-.22-.26-.13-.48-.56-.2-.46-.24-1.02-.61-.8z'
      fill='url(#mass_app2_svg__SVGID_39_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_40_'
      gradientUnits='userSpaceOnUse'
      x1={150.701}
      y1={84.764}
      x2={153.573}
      y2={81.892}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M153.18 81.6c-.06.21-.37.26-.59.48-.22.22 0 .3-.63.74-.63.43-1.4.91-1.54 1.3-.15.39.15.61.74.65.59.04.44.17.85-.35.4-.52.77-.83 1.25-1.26.48-.44.48-1.09.48-1.09s-.53-.6-.56-.47z'
      fill='url(#mass_app2_svg__SVGID_40_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_41_'
      gradientUnits='userSpaceOnUse'
      x1={141.018}
      y1={82.932}
      x2={142.337}
      y2={81.612}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M140.9 81.94c-.41.48.4.48.29.96-.11.48.55.3.74.22.18-.09.63-1.09.55-1.35-.07-.26-.81.43-.99.39-.19-.04-.59-.22-.59-.22z'
      fill='url(#mass_app2_svg__SVGID_41_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_42_'
      gradientUnits='userSpaceOnUse'
      x1={130.335}
      y1={81.055}
      x2={142.457}
      y2={68.933}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M138.21 78.56c0-.44-.22.48-.37.09s.15-1.04-.22-.78-.55.48-.59.7c-.04.22-.7.3-.66.09.04-.22.29-.74.04-.96-.26-.22-.7-.3-1.03-.43-.33-.13.04-.56-.85-.35-.88.22-1.21.48-1.21.48s-.81-.3-1.07.04c-.26.35-.4 1.45-.4 1.45s-1.25-.41-1.47-.37c-.22.04-.59.39-.92.52-.33.13-.88.26-1.1.04-.22-.22-.59-.61-.48-.87.11-.26.92-.61.63-1.04-.3-.43-.48-.52-.52-.78-.04-.26.11-.39-.33-.91s-.33-1.13-.15-1.22c.18-.09-.61-.61-.76-.83-.15-.22.35-1 .65-1.22.29-.22 1.18-1.04 1.43-1.04.26 0 .66.13.92-.09s1.03-.13 1.03-.3c0-.17-.21-1.57-.03-1.79.18-.22 1.24.27 1.36.09.11-.17.29-.91.51-1.04.22-.13.41-.43.74 0s.66.61.81.17c.15-.43.04-.3.37-.7.33-.39-.04-1.04.3-.65.33.39.55.7.55.7s-.04-.87.18-.87.44.43.55.43c.11 0 1.1-.26 1.29.04.18.3-.52 1.13-.26 1.43.26.3.77.48 1.14.74.37.26.81.87.99.35.18-.52.55-1.3.29-1.69-.26-.39.07-1.65.18-1.74.11-.09.29 1 .66 1.48.37.48.74.82.92 1.35.18.52.22 1.43.55 1.74.33.3 1.6.28 1.57.67-.04.39.13 1.15.53 1.89.41.74 1.19 2.47 1.19 3.16 0 .7-1.19 1.49-1.52 2.01-.33.52-.44 1.22-.59 1.48-.15.26-.07.22-.63.39-.55.17-.96.69-1.1.52-.15-.17-.66-.48-.81-.26-.15.22-.33.69-.59.17-.26-.52-.85-.43-.96-.52-.11-.09-.11-.35-.11-.78 0-.43-.48-.48-.52-.61-.02-.12-.13-.25-.13-.38z'
      fill='url(#mass_app2_svg__SVGID_42_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_43_'
      gradientUnits='userSpaceOnUse'
      x1={155.244}
      y1={70.123}
      x2={156.205}
      y2={69.162}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path d='M155.16 70.04c.48.22 1.32-.78.99-.91-.32-.13-.99.91-.99.91z' fill='url(#mass_app2_svg__SVGID_43_)' />
    <linearGradient
      id='mass_app2_svg__SVGID_44_'
      gradientUnits='userSpaceOnUse'
      x1={149.76}
      y1={72.096}
      x2={150.199}
      y2={71.657}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M150.49 72.21c-.07.42-.51.22-.74-.17-.22-.39-.66-.7 0-.52.67.17.78.48.74.69z'
      fill='url(#mass_app2_svg__SVGID_44_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_45_'
      gradientUnits='userSpaceOnUse'
      x1={120.805}
      y1={61.898}
      x2={122.517}
      y2={60.187}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M119.5 58.05c-.46.11.66 1.04.77 1.17.11.13 1.1 1.13 1.1 1.61 0 .48.32 1.96.5 2.14.18.17 1.44.47 1.59.82.15.35.48.43.48-.04 0-.48.07-1.04.26-1.3.18-.26.11-.65-.18-.61-.29.04-.55-.57-1.03-.96s-.85-.65-1.29-1.22c-.44-.56-.99-.91-1.29-1.22-.29-.3-.73-.43-.91-.39z'
      fill='url(#mass_app2_svg__SVGID_45_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_46_'
      gradientUnits='userSpaceOnUse'
      x1={121.43}
      y1={58.782}
      x2={122.697}
      y2={57.514}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M120.93 55.75c-.29.04-.29.7-.15.91.15.22.44.09.63.87.18.78.55 1.56.7 1.87.15.3.77.74.99.95.22.22.55-.09.4-.35-.15-.26-.44-.65-.48-.96-.04-.3-.22-.78-.51-1.3-.29-.52-.55-.65-.74-1-.18-.34-.84-.99-.84-.99z'
      fill='url(#mass_app2_svg__SVGID_46_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_47_'
      gradientUnits='userSpaceOnUse'
      x1={124.309}
      y1={64.858}
      x2={125.157}
      y2={64.009}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M124.02 63.96c-.27.4.07.69.18.78.11.09.52.17.88.13.37-.04.88-.17.48-.43-.41-.26-.88 0-1.03-.35-.14-.35-.36-.35-.51-.13z'
      fill='url(#mass_app2_svg__SVGID_47_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_48_'
      gradientUnits='userSpaceOnUse'
      x1={126.317}
      y1={65.361}
      x2={127.258}
      y2={64.42}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M126.15 64.31c-.26.13-.66.22-.37.52.29.3.48.43.92.39.44-.04 1.1.26 1.14 0 .04-.26-.4-.65-.59-.65-.18 0-1.1-.26-1.1-.26z'
      fill='url(#mass_app2_svg__SVGID_48_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_49_'
      gradientUnits='userSpaceOnUse'
      x1={129.846}
      y1={66.029}
      x2={130.268}
      y2={65.606}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path d='M129.76 65.74c-.08.39.55.56.59.13.03-.43-.52-.48-.59-.13z' fill='url(#mass_app2_svg__SVGID_49_)' />
    <linearGradient
      id='mass_app2_svg__SVGID_50_'
      gradientUnits='userSpaceOnUse'
      x1={131.773}
      y1={66.186}
      x2={132.905}
      y2={65.054}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M131.71 66.04c.06.47.81-.26.81-.26s.59-.09.59-.39c0-.3-.59-.7-.81-.35-.23.35-.63.7-.59 1z'
      fill='url(#mass_app2_svg__SVGID_50_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_51_'
      gradientUnits='userSpaceOnUse'
      x1={130.047}
      y1={63.208}
      x2={131.751}
      y2={61.504}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M130.09 61.18c-.22.09-.18.3-.26.74-.07.43-.41.74-.11.96.29.22.85-.74.99-.43.15.3-.04.43.22.83.26.39.74.35.74.35s-.04-1.04-.44-1.3-.66-.56-.18-.48c.48.09.74-.13.63-.39-.11-.26-.81-.13-1.03-.09-.23.03-.56-.19-.56-.19z'
      fill='url(#mass_app2_svg__SVGID_51_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_52_'
      gradientUnits='userSpaceOnUse'
      x1={130.607}
      y1={61.116}
      x2={131.986}
      y2={59.737}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M130.31 60.31c-.26.3-.07.61.33.57.4-.04 1.25-.17 1.43-.17.19 0 .44-.56.29-.56-.15 0-1.18.22-1.29.26-.1.03-.76-.1-.76-.1z'
      fill='url(#mass_app2_svg__SVGID_52_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_53_'
      gradientUnits='userSpaceOnUse'
      x1={133.268}
      y1={61.02}
      x2={134.325}
      y2={59.963}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path d='M134.06 59.7c-.34-.17-.96 1.43-.51 1.56.43.14.77-1.43.51-1.56z' fill='url(#mass_app2_svg__SVGID_53_)' />
    <linearGradient
      id='mass_app2_svg__SVGID_54_'
      gradientUnits='userSpaceOnUse'
      x1={126.091}
      y1={62.195}
      x2={129.981}
      y2={58.306}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M129.02 57.4c-.01-.31-.59.09-.63.39-.04.3.41.57-.29.57s-.73.65-.88.78c-.15.13-.3.17-.59.26s-.37.43-.44.65c-.07.22-.59-.39-.73-.22-.15.17-.04 1 .22 1.7.26.69.92 1.13 1.1 1.13.18 0 .55 0 .81.09s1.1.17 1.07-.22c-.04-.39-.11-1 .26-1.39.37-.39.74-.61.55-1.17-.18-.56-.55-.91-.3-1.17.26-.26.55-.35.55-.57 0-.22-.63.6-.7-.83z'
      fill='url(#mass_app2_svg__SVGID_54_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_55_'
      gradientUnits='userSpaceOnUse'
      x1={129.295}
      y1={54.61}
      x2={131.811}
      y2={52.093}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M130.82 51.27c-.26 0 .04.48-.33.78-.37.3-.77.43-.55.95.22.52.99.91.81 1.13-.18.22-.73.65-.81 1.04-.07.39.88-.61 1.14-1 .26-.39.77-.17.88-.39l.11-.22s-.4-.09-.73-.22c-.33-.13-.74.35-.55-.35.18-.69.74-.56.63-1.09-.12-.5-.49-.63-.6-.63z'
      fill='url(#mass_app2_svg__SVGID_55_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_56_'
      gradientUnits='userSpaceOnUse'
      x1={131.113}
      y1={55.964}
      x2={131.757}
      y2={55.32}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M131.15 55.05c-.13.05-.44.83-.04.83s1.1.13.95-.09c-.13-.22-.5-.91-.91-.74z'
      fill='url(#mass_app2_svg__SVGID_56_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_57_'
      gradientUnits='userSpaceOnUse'
      x1={132.12}
      y1={55.184}
      x2={132.719}
      y2={54.586}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path d='M132.37 54.4c-.15-.01-.62.91.04.87.66-.04.47-.83-.04-.87z' fill='url(#mass_app2_svg__SVGID_57_)' />
    <linearGradient
      id='mass_app2_svg__SVGID_58_'
      gradientUnits='userSpaceOnUse'
      x1={131.345}
      y1={57.62}
      x2={132.719}
      y2={56.247}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M132.48 56.01c-.52.78-.48.61-.85.43-.37-.17-.96.39-.85.61.11.22.92-.04 1.1.35.18.39.18.43.55.35.37-.09.74-.69.63-1-.1-.31-.58-.74-.58-.74z'
      fill='url(#mass_app2_svg__SVGID_58_)'
    />
    <linearGradient
      id='mass_app2_svg__SVGID_59_'
      gradientUnits='userSpaceOnUse'
      x1={137.706}
      y1={65.124}
      x2={140.406}
      y2={62.423}
    >
      <stop offset={0} stopColor='#fd5c1f' stopOpacity={0.1} />
      <stop offset={1} stopColor='#fd5c1f' stopOpacity={0.4} />
    </linearGradient>
    <path
      d='M134.98 61.14c-.28.33-.41.35.22.48.62.13.81.13.55.48s-.44.78-.22.83c.22.04.88-.17.96 0 .07.17-.15.22.59.35.74.13.88.44 1.03.61.15.17.59.74.29.74-.29 0-.62.43-.4.48.22.04.88-.13.92 0 .04.13.41.96.77.91.37-.04.59-.83.77-1.04.18-.22.92-.35.99.04.07.39.29.78.74 1.04.44.26.96.52.99.3.04-.22-.22-1.04-.52-1.17-.29-.13-.81-.87-.81-1.17 0-.3-.44-.39-.66-.61-.22-.22-.4-.83-.96-.96-.55-.13-.7-.35-1.29-.69-.59-.35-1.91-.35-1.95-.13-.04.22 0 0-.44-.17s-.77 0-.88-.3c-.1-.33-.36-.42-.69-.02z'
      fill='url(#mass_app2_svg__SVGID_59_)'
    />
    <g>
      <path className='mass_app2_svg__st59' d='M28.32 24.64s84.34.4 105.45 50.11M45.59 61.27s-2.61-37.28 38.75-23.34' />
      <path
        className='mass_app2_svg__st59'
        d='M141.63 25.04S85.8 31.47 88.69 69.59c0 0-19.34-20.75-43.1-8.32 6.28-30.86-17.27-36.64-17.27-36.64s41.57-12.8 55.93 13.95C106 4.23 141.63 25.04 141.63 25.04s21.4 23.95-7.87 49.7c0 0-51.67-13.65-49.52-36.16M88.69 69.59s25.3-14.52 45.08 5.15'
      />
    </g>
    <path
      className='mass_app2_svg__st60'
      d='M55.47 60.26c0 5.89-4.78 10.67-10.67 10.67s-10.67-4.78-10.67-10.67 4.78-10.67 10.67-10.67 10.67 4.78 10.67 10.67zM149.4 24.29c0 4.71-3.82 8.54-8.53 8.54-4.71 0-8.54-3.82-8.54-8.54 0-4.71 3.82-8.53 8.54-8.53 4.71 0 8.53 3.82 8.53 8.53z'
    />
    <g>
      <path
        className='mass_app2_svg__st61'
        d='M142.72 19.17h-6.12v10.24h8.53v-8.04l-2.41-2.2zm-5.27 9.39v-8.53h4.27v1.71h2.56v6.83h-6.83zm-.27-.35'
      />
      <path
        className='mass_app2_svg__st61'
        d='M138.3 23.44h5.12v.85h-5.12zM138.3 25.15h5.12V26h-5.12zM138.3 26.86h5.12v.85h-5.12z'
      />
    </g>
    <path
      className='mass_app2_svg__st60'
      d='M94.99 34.96c0 4.71-3.82 8.54-8.53 8.54-4.71 0-8.54-3.82-8.54-8.54 0-4.71 3.82-8.53 8.54-8.53 4.71 0 8.53 3.82 8.53 8.53z'
    />
    <g>
      <path
        className='mass_app2_svg__st61'
        d='M88.31 29.84h-6.12v10.24h8.54v-8.04l-2.42-2.2zm-5.27 9.39V30.7h4.27v1.71h2.56v6.83h-6.83zm-.27-.35'
      />
      <path
        className='mass_app2_svg__st61'
        d='M83.89 34.11h5.12v.85h-5.12zM83.89 35.82h5.12v.85h-5.12zM83.89 37.52h5.12v.85h-5.12z'
      />
    </g>
    <path
      className='mass_app2_svg__st60'
      d='M37.52 23.15c0 5.89-4.78 10.67-10.67 10.67s-10.67-4.78-10.67-10.67 4.78-10.67 10.67-10.67c5.9 0 10.67 4.78 10.67 10.67zM142.42 73.21c0 5.83-4.73 10.56-10.56 10.56s-10.56-4.73-10.56-10.56 4.73-10.56 10.56-10.56 10.56 4.73 10.56 10.56z'
    />
    <g>
      <path className='mass_app2_svg__st61' d='M133.89 67H127v12h10v-9.21L133.89 67zM128 78V68h5v2h3v8h-8zm-.7.06' />
      <path className='mass_app2_svg__st61' d='M129 72h6v1h-6zM129 74h6v1h-6zM129 76h6v1h-6z' />
    </g>
    <g>
      <path
        className='mass_app2_svg__st61'
        d='M46.69 54.26H39.8v12h10v-9.21l-3.11-2.79zm-5.89 11v-10h5v2h3v8h-8zm-.7.05'
      />
      <path className='mass_app2_svg__st61' d='M41.8 59.26h6v1h-6zM41.8 61.26h6v1h-6zM41.8 63.26h6v1h-6z' />
    </g>
    <g>
      <path
        className='mass_app2_svg__st61'
        d='M28.74 17.15h-6.89v12h10v-9.21l-3.11-2.79zm-5.89 11v-10h5v2h3v8h-8zm-.7.05'
      />
      <path className='mass_app2_svg__st61' d='M23.85 22.15h6v1h-6zM23.85 24.15h6v1h-6zM23.85 26.15h6v1h-6z' />
    </g>
    <g>
      <path
        className='mass_app2_svg__st60'
        d='M97 67.93c0 4.67-3.78 8.45-8.45 8.45s-8.45-3.78-8.45-8.45 3.78-8.45 8.45-8.45S97 63.26 97 67.93z'
      />
      <path
        className='mass_app2_svg__st61'
        d='M90.39 62.86h-6.06V73h8.45v-7.96l-2.39-2.18zm-5.22 9.29V63.7h4.23v1.69h2.54v6.76h-6.77zm-.27-.35'
      />
      <path
        className='mass_app2_svg__st61'
        d='M86.02 67.08h5.07v.85h-5.07zM86.02 68.77h5.07v.85h-5.07zM86.02 70.46h5.07v.85h-5.07z'
      />
    </g>
  </svg>
)

export default SvgMassApp2
